<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Limits"
              bc1="App"
              bc2="Limits"
              bc3="List"
              path="schemas"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div  v-if="limitData" class="card">
          <div class="row mt-2">
            <div class="col-8">
              <div class="card" v-if="limitData">
                <div class="card-header">
                  <h4 class="card-title">Details</h4>
                </div>
                <div class="card-body" v-if="limitData">
                  <div class="row bg">
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark ">Min Limit</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning">{{limitData.min_limit?parseFloat(limitData.min_limit/100).toFixed(amountDecimalPlaces):'N/A'}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark ">Max Limit</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning">{{limitData.max_limit?parseFloat(limitData.max_limit/100).toFixed(amountDecimalPlaces):'N/A'}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-3">
                          <p class="text-dark ">Status</p>
                        </div>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <p class="text-warning">{{limitData.status?'Active':'Inactive'}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="d-flex align-items-center justify-content-end mr-1 mb-1">
                <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="$router.push({ name: 'manage-aquiring-limits',params: {acquiringId :schemaAquiringId}})"
                >
                  <span class="text-nowrap">Manage</span>
                </button>
              </div>
            </div>
          </div>
          <div class="card" v-if="limitData && limitData.other_settings">

              <div class="card-header">
                <h4 class="card-title">Other Settings</h4>
              </div>
              <div class="card-body">
                <div class="form-group row" v-for="(value,key) in limitData.other_settings">
                  <div class="col-sm-3">
                    <p class="text-dark ">{{key}}</p>
                  </div>
                  <div class="col-sm-9">
                    <div class="input-group">
                      <p class="text-info">{{value}}</p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div v-else class="card" >
          <div class="card-body">
            <div class="row d-flex justify-content-center">
              <h4>
                No Data Available
              </h4>
            </div>
            <div class="row d-flex justify-content-center">
              <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="$router.push({ name: 'manage-aquiring-limits',params: {acquiringId :schemaAquiringId}})"
              >
                <span class="text-nowrap">Manage</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


export default {
  mounted() {
    var schemaAcquiringTransactionTypes = this.$store.getters.getByKey(
        "schemaAcquiringTransactionTypesLimits"
    );
    this.schemaAquiringId = parseInt(atob(this.$route.params.acquiringId))
    // this.schemaAquiringId = 1
    this.aquiringTransactionTypeId = schemaAcquiringTransactionTypes.row.pivot.id
    // this.aquiringTransactionTypeId = 1

    this.getLimits()
  },
  data() {
    return {
      aquiringTransactionTypeId:'',
      schemaAquiringId:'',
      limitData:null

    };
  },
  methods: {
    getLimits() {
      let data ={
        aquiringTransactionTypeId : this.aquiringTransactionTypeId,
        schemaAquiringId : this.schemaAquiringId,
      }
      this.makeRequest(
          "post",
          "v1/get-schema-aquiring-limits",
          data,
          {},
          false
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.limitData = callResponse.response.data.data
          }
        }
      });
    },

  },

};
</script>

